import * as S from './styles';
import Card, { Props } from './card';
import { useRef, useState, useEffect, useCallback } from 'react';

const CardContent = (props: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [elementHeight, setElementHeight] = useState<number | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const hasCheckedInitialRef = useRef(false);

  const checkVisibility = useCallback(() => {
    if (!containerRef.current) return false;
    const rect = containerRef.current.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < windowHeight + 150 && rect.bottom > -150;
  }, []);

  const handleIntersection = useCallback((entries: IntersectionObserverEntry[]) => {
    const [entry] = entries;
    setIsVisible(entry.isIntersecting);
  }, []);

  useEffect(() => {
    if (isVisible && contentRef.current && !elementHeight) {
      const height = contentRef.current.offsetHeight;
      if (height > 0) {
        setElementHeight(height);
      }
    }
  }, [isVisible, elementHeight]);

  useEffect(() => {
    if (!containerRef.current) return;

    if (!hasCheckedInitialRef.current) {
      hasCheckedInitialRef.current = true;
      if (checkVisibility()) {
        setIsVisible(true);
      }
    }

    observerRef.current = new IntersectionObserver(handleIntersection, {
      threshold: 0,
      rootMargin: '450px',
    });

    observerRef.current.observe(containerRef.current);

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [handleIntersection, checkVisibility]);

  return (
    <S.CardContainer ref={containerRef} id={`client-${props.client.COD_CLIENTE}`}>
      {isVisible ? (
        <S.ContentWrapper ref={contentRef}>
          <Card {...props} />
        </S.ContentWrapper>
      ) : (
        <S.Placeholder style={{ height: elementHeight || 'auto' }} />
      )}
    </S.CardContainer>
  );
};

export default CardContent;
